export namespace PROPOSAL_OPTION_KEY {
    export const BOTTOM_LINE_PRICE_LEVEL_ID = "bottom-line-price-level-id"

}


// WEBPACK FOOTER //
// ./src/state/proposal/ProposalOptionKey.ts